import { IPortalForm } from "./PortalForm";
import { DateService } from "../../service/DateService";

export interface IPortalFormPresentationModel {
  id: number;
  publicationDate?: string;
  name: string;
}

const PortalFormPresentationModel = (
  data: IPortalForm
): IPortalFormPresentationModel => {
  const publicationDate = data.publicationDate
    ? DateService().formatDate(data.publicationDate)
    : undefined;

  return {
    ...data,
    publicationDate
  };
};

export default PortalFormPresentationModel;
